$(document).on('click', '.verplano', function() {
    let planta = $(this).data('planta');
    let mapaURL = $(this).data('mapa');
    if (planta == '-1' ) planta = '1';
    if (planta == 'ambas') planta = '0';

    const baseURL = `/storage/locales/mapa-general-${planta}.png`;

    $('#mapaBase').attr('src', baseURL);
    $('#capaTienda').attr('src', mapaURL); 
 
     $('#planoModal').fadeIn();
});

$(document).on('click', '.cerrar-modal, #planoModal', function(e) {
    // Cerrar si se hace clic fuera del contenido o en la X
    if (e.target.id === 'planoModal' || $(e.target).hasClass('cerrar-modal')) {
        $('#planoModal').fadeOut();
    }
});